<template>
  <base-edit :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template slot="images" slot-scope="{ input }">
      <ImageList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
      />
    </template>
  </base-edit>
</template>

<script>
  import TextList from '../../components/field/text-list';
  import ImageList from '../../components/field/images-list';
  import RadioField from '../../components/field/radio';

export default {
  components: {
    TextList,
    ImageList,
    RadioField
  },
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resourceName: "makers",
      fields: [
        {
          label: "企業名",
          name: "maker_name",
          rules: "required|max:255",
          width: "60%"
        },
        {
          label: "企業名(かな)",
          name: "name_kana",
          rules: "required|max:255|kana",
          width: "60%"
        },
        {
          label: "企業ロゴ画像",
          name: "logo",
          type: "file"
        },
        {
          label: "紹介文言",
          name: "description",
          width: "100%"
        },
        {
          label: "コーポレートサイトURL",
          name: "website_url",
          width: "60%"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
    if(this.isProvider) {
      return [
        {
          text: "メーカー一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "メーカー編集",
          disabled: true
        }
      ];
    } else {
      return [
        {
          text: "企業情報編集",
          disabled: true
        }
      ];
    }

    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    }
  },
  mounted() {
    const vm = this;

    if(this.isProvider) {
      this.fields.push(
        {
          label: "契約プラン",
          name: "plan_num",
          type: "select",
          optionType: "common/plans",
          rules: "required",
          width: "60%"
        },
        {
          label: "契約(予定)開始日",
          name: "contract_start_from",
          type: "date",
          rules: "required",
          width: "100%"
        },
        {
          label: "契約更新日",
          name: "contract_update_at",
          type: "date",
          width: "100%"
        },
        {
          label: "契約(予定)終了日",
          name: "contract_end_at",
          type: "date",
          width: "100%"
        },
        {
          label: "フリー欄",
          name: "additional_comments",
          type: "custom",
          width: "60%"
        }
      );
    } else {
      this.fields.push(
        {
          label: "契約プラン",
          name: "plan_num",
          type: "display",
          optionType: "common/plans",
          render(value) {
            return vm.optionName("common/plans", value);
          }
        },
        {
          label: "契約(予定)開始日",
          name: "contract_start_from",
          type: "display"
        },
        {
          label: "契約更新日",
          name: "contract_update_at",
          type: "display"
        },
        {
          label: "契約(予定)終了日",
          name: "contract_end_at",
          type: "display"
        }
      );
    }
  }

};
</script>
